import { render, staticRenderFns } from "./monitorPage.vue?vue&type=template&id=67fcb4c8&scoped=true"
import script from "./monitorPage.vue?vue&type=script&lang=js"
export * from "./monitorPage.vue?vue&type=script&lang=js"
import style0 from "./monitorPage.vue?vue&type=style&index=0&id=67fcb4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fcb4c8",
  null
  
)

export default component.exports